import React from 'react'
import { FormControl, Form } from "react-bootstrap"
import TableData from "../../../../_components/TableData"
import Text from '../../../../_components/Text'
import { getPaymentMethods, getCustomPaymentMethods, CreateCustomPaymentMethods } from '../../../../api/payments'
import { formatDate, formatCurrencyValue, formateCurrentDate } from '../../../../utils'
import CurrencyInput from "react-currency-input"
import Button from '../../../../_components/Button'
import LoadingInput from '../../../../_components/LoadingInput'
import Modal from '../../../../_components/Modal'
import PaymentCategory from '../PaymentCategory'
import PaymentCostCenter from '../PaymentCostCenter'
import IconButton from '../../../../_components/IconButton'
import Filters from '../Filters'
import Dropdown, { DropDownDivider, DropDownItem } from '../../../../_components/Dropdown'
import { CreateTransaction, filterTransaction, ConfirmTransaction, CancelTransaction, totalTransaction, UpdateTransaction } from '../../../../api/financial'
import Dialog from '../../../Fiscal/NFe/Issuer/Dialog'
import { toast as toastify } from "react-toastify"
import { getClients } from '../../../../api/clients'
import AutoComplete from '../AutoComplete'
import translations from '../languages'
import CheckBox from '../../../../_components/Checkbox'

import { useMenuNavigation } from "../../Sidebar/hooks"
import appContext from "../../context"
import DownloadReport from '../../../Fiscal/NFe/List/DownloadReport'
import { startTrial } from '../../../../api/financial'

export default props => {
    const ref = React.useRef(null)

    const [_, accessFinancialModule] = useMenuNavigation()
    const context = React.useContext(appContext)

    const [data, setData] = React.useState({
        type: 1, payment: {
            value: 0,
            due_date: formateCurrentDate(),
            payment_method: "4bf2b774-3476-49fc-bb26-591e363a415d",
            paid_value: 0
        },
        cost_type: 1,
    })
    const [customPaymentMethod, setCustomPaymentMethod] = React.useState("")
    const [loading, setLoading] = React.useState(false)
    const [show, setShow] = React.useState(false)
    const [tempShow, setTempShow] = React.useState(false)
    const [ShowAlertConfirmPay, setShowAlertConfirmPay] = React.useState(false)
    const [ShowAlertCancelPay, setShowAlertCancelPay] = React.useState(false)
    const [ShowAlertEditPay, setShowAlertEditPay] = React.useState(false)
    const [ShowAlertDetails, setShowAlertDetails] = React.useState(false)
    const [ShowNotAllowed, setShowNotAllowed] = React.useState(false)
    const [tempValue, setTempValue] = React.useState(0)
    const [tempPaidValue, setTempPaidValue] = React.useState(0)
    const [changeableValue, setChangeableValue] = React.useState(0)
    const [tempDiscountValue, setTempDiscountValue] = React.useState(0)
    const [tempDueDate, setTempDueDate] = React.useState(0)
    const [tempTax, setTempTax] = React.useState(0)
    const [tempPenalty, setTempPenalty] = React.useState(0)
    const [paymentMethodsList, setPaymentMethodsList] = React.useState([])
    const [customPaymentMethodsList, setCustomPaymentMethodsList] = React.useState([])
    const [allPaymentMethodsList, setAllPaymentMethodsList] = React.useState([])
    const [transactionList, setTransactionList] = React.useState([])
    const [currentTransaction, setCurrentTransaction] = React.useState({})
    const [totalData, setTotalData] = React.useState({ to_receive: 0, received: 0 })
    const [language, setLanguage] = React.useState('pt')
    const [repeatShow, setRepeatShow] = React.useState(false)
    const [fastFilter, setfastFilter] = React.useState(false)
    const [reportParams, setReportParams] = React.useState({ type: 1 })

    const [showTrial, setShowTrial] = React.useState(false)
    const [trialDate, setTrialDate] = React.useState(false);


    const handleChangeLanguage = (event) => {
        setLanguage(event.target.value)
    }

    const international = translations[language]

    const StatusChoices = {
        1: international.paymentsIn.screenTexts.toReceive,
        2: international.paymentsIn.screenTexts.received,
        3: international.paymentsIn.screenTexts.canceled,
        4: "Vencido",
        5: "Renegociado"
    }

    const costTypeChoices = {

        1: international.paymentsIn.modalFields.cost_type.variable,
        2: international.paymentsIn.modalFields.cost_type.fixed,
    }

    function onHandleShow() {
        if (loading) {
            return
        }
        setShow(!show)
    }

    function onHandleTempShow() {
        if (loading) {
            return
        }
        setTempShow(!tempShow)
    }

    const handleRepeatShow = () => {
        setRepeatShow(prevIsToggled => !prevIsToggled)
    }

    //foi sugerido que, no futuro, esse tipo de função que faz uma requisição para pegar
    //métodos de pagamentos seja abolida,
    // um JSON com as informações talvez seria mais interessante

    function getFieldValue(obj, path) {
        const pathParts = path.split(':')
        let current = obj

        for (let pathPart of pathParts) {
            if (current === null || current === undefined) {
                return null
            }
            current = current[pathPart]
        }

        return current
    }

    function isObjectOrArray(value) {
        return value && (typeof value === 'object' || Array.isArray(value))
    }

    function isEmptyObjectOrArray(value) {
        return isObjectOrArray(value) && Object.keys(value).length === 0
    }

    function isValid() {
        const modalElement = document.getElementById("modal-create")
        const requiredFields = modalElement.querySelectorAll("[required]")

        const toggleIsInvalid = (element, isValid) => {
            const action = isValid ? 'remove' : 'add'
            element.classList[action]("is-invalid")
        }

        let isValid = true
        requiredFields.forEach(field => {
            const fieldValue = getFieldValue(data, field.name)


            const isFieldValid =
                fieldValue !== null &&
                fieldValue !== undefined &&
                fieldValue !== '' &&
                fieldValue !== 0 &&
                !isEmptyObjectOrArray(fieldValue)


            toggleIsInvalid(field, isFieldValid)

            if (!isFieldValid) {
                isValid = false
            }
        })

        return isValid
    }



    function onChange(e) {

        let { name, value } = e.target //separa  oque vem da função
        let tempData = { ...data }

        if (name.includes(':')) { // cria um objeto encadeado caso "name" tenha ":", ex: payment:value vira payment:{value:0}
            const [key, child] = name.split(':')
            tempData[key][child] = value

            if (name == 'payment:value') {
                setTempValue(value)
            }
            if (name == 'payment:paid_value') {
                setTempPaidValue(value)
            }

        } else {
            tempData[name] = value
        }
        setData(tempData)
    }

    function _createTransaction() {

        setLoading(true)
        if (!isValid()) {
            toastify.error("Preencha os campos marcados como necessários*!.", { position: "top-center" })
            return
        }
        CreateTransaction(data)
            .then(() => {
                toastify.success("Conta a Receber criada.", { position: "top-center" })
                setTimeout(() => {
                    {
                        window.location.reload()
                        setLoading(false)
                    }
                }, 2000)
            })
            .catch(() => {
                toastify.error("Erro ao Criar conta a receber", { position: "top-center" })
            })
    }

    async function search(args = { type: 1 }) {
        setReportParams(args)
        _getTransacations(args)
    }

    function PayTransaction() {

        ConfirmTransaction(currentTransaction.id, { value: tempPaidValue, discount: tempDiscountValue, due_date: tempDueDate, tax: tempTax, penalty: tempPenalty })
            .then(d => {
                toastify.success("Conta recebida com sucesso", {
                    position: "top-center"
                })
                setTimeout(() => {
                    window.location.reload()
                }, 2000)
            })
    }

    function getTotal(params = { pay_in: true, pay_out: true }) {

        totalTransaction(params).then(resp => {
            console.log(resp)
        })
    }


    function CancelationTransaction() {


        CancelTransaction(currentTransaction.id).then(d => {

            toastify.success("Conta cancelada com sucesso", {
                position: "top-center"
            })
            setTimeout(() => {
                window.location.reload()

            }, 2000)
        })
    }

    function UpdateTransactionData() {
        // console.log(currentTransaction)
        UpdateTransaction(
            currentTransaction.id, {
            payment: {
                value: changeableValue,
                due_date: currentTransaction.due_date.slice(0, 10),
                payment_method: currentTransaction.payment_method.id
            },
            // type: 1,
            // cost_type:currentTransaction.cost_type,
            // description: currentTransaction.description
        })
            .then(d => {
                toastify.success("Conta editada com sucesso", {
                    position: "top-center"
                })
                setTimeout(() => {
                    window.location.reload()

                }, 2000)
            })
    }



    async function _getTransacations(params = { type: 1 }) {
        await filterTransaction(params)
            .then(result => {
                let to_receive = 0
                let received = 0
                result = result.reverse().map((mappedItem, index) => {
                    if (mappedItem.status == 1) {
                        to_receive += mappedItem.value
                        var currentDatePlusOneDay = new Date();
                        currentDatePlusOneDay.setDate(currentDatePlusOneDay.getDate() + 1);
                        if (new Date(mappedItem.due_date) < currentDatePlusOneDay) {
                            mappedItem.overdue = true
                        }
                    }
                    if (mappedItem.status == 2) { received += mappedItem.paid_value }
                    if (mappedItem.value != mappedItem.paid_value
                        && mappedItem.status != 1
                        && mappedItem.paid_value != null
                        && mappedItem.paid_value != 0) { mappedItem.status = 5 }
                    return {
                        ...mappedItem,
                        value: formatCurrencyValue(mappedItem.value),
                        idx: index + 1,
                        status: StatusChoices[mappedItem.overdue ? 4 : mappedItem.status], // colocar texto em vermelho, fazer a tradução
                        cost_center: mappedItem.cost_center ? mappedItem.cost_center.name : international.paymentsIn.screenTexts.notInformed,
                        category: mappedItem.category ? mappedItem.category.name : international.paymentsIn.screenTexts.notInformed,
                        payment_method: mappedItem.payment_method.name,
                        recipient: mappedItem.recipient ? mappedItem.recipient.name : international.paymentsIn.screenTexts.notInformed,
                        due_date: formatDate(mappedItem.due_date, false),
                        description: mappedItem.description,
                        cost_type: mappedItem.cost_type == 1 ? "Custo Variável" : mappedItem.cost_type == 2 ? "Custo Fixo" : "Não Informado",
                        actions: <Dropdown>

                            <DropDownItem>
                                <Button
                                    disabled={mappedItem.status != 1}
                                    as="text"
                                    className="text-info mx-1"
                                    onClick={() => {
                                        setCurrentTransaction(mappedItem)
                                        setShowAlertConfirmPay(true)
                                        setTempPaidValue(mappedItem.value)
                                        setTempDueDate(mappedItem.due_date.slice(0, 10))

                                    }}
                                >
                                    <i className="fas fa-money-bill-wave" />{" "}
                                    <span>{international.paymentsIn.actions.confirm.labelText}</span>
                                </Button>
                            </DropDownItem>

                            <DropDownDivider />

                            <DropDownItem>
                                <Button
                                    as="text"
                                    className="text-dark mx-1"
                                    onClick={() => {
                                        setCurrentTransaction(mappedItem)
                                        setShowAlertEditPay(true)
                                    }}
                                >
                                    <i className="fas fa-edit" />{" "}
                                    <span>Editar Conta</span>
                                </Button>
                            </DropDownItem>

                            <DropDownDivider />

                            <DropDownItem>
                                <Button
                                    as="text"
                                    className="text-dark mx-1"
                                    onClick={() => {
                                        setCurrentTransaction(mappedItem)
                                        setShowAlertDetails(true)
                                    }}
                                >
                                    <i className="fa fa-eye" />{" "}
                                    <span>{international.paymentsIn.actions.details.labelText}</span>
                                </Button>
                            </DropDownItem>

                            <DropDownDivider />

                            <DropDownItem>
                                <Button
                                    as="text"
                                    className="text-danger mx-1"
                                    onClick={() => {
                                        setCurrentTransaction(mappedItem)
                                        setShowAlertCancelPay(true)
                                    }}
                                >
                                    <i className="fa fa-times" />{" "}
                                    <span>Cancelar Conta</span>
                                </Button>
                            </DropDownItem>

                        </Dropdown>
                    }
                })
                setTransactionList(result)
                setTotalData({ to_receive, received })
            })
    }

    function _getCustomPaymentMethods() {

        getCustomPaymentMethods()
            .then(pays => console.log(pays))

    }

    function _createCustomPaymentMethod(methodName) {

        CreateCustomPaymentMethods(methodName)
            .then(resp => {
                toastify.success("método de pagamento criado.", { position: "top-center" })
            })
            .catch(() => {
                toastify.error("Erro ao Criar método de pagamento", { position: "top-center" })
            })
    }

    function handleChangeFastFilter(type) {

        const today = new Date();
        let firstDayOfMonth = 0
        let lastDayOfMonth = 0
        let firstDayOfYear = 0
        let lastDayOfYear = 0
        let firstDayOfLastYear = 0
        let lastDayOfLastYear = 0
        let todayStr = today.toISOString().split('T')[0]
        let futureDate = new Date()
        futureDate.setDate(today.getDate() + 16)
        let futureDateStr = 0


        if (type == 1) {
            firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0]
            lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0]
            search({
                type: 1,
                end_due_date: lastDayOfMonth,
                start_due_date: firstDayOfMonth
            })
        }

        if (type == 2) {
            firstDayOfYear = new Date(today.getFullYear(), 0, 1).toISOString().split('T')[0];
            lastDayOfYear = new Date(today.getFullYear(), 11, 31).toISOString().split('T')[0];
            search({
                type: 1,
                end_due_date: lastDayOfYear,
                start_due_date: firstDayOfYear
            })
        }

        if (type == 3) {
            firstDayOfLastYear = new Date(today.getFullYear() - 1, 0, 1).toISOString().split('T')[0];
            lastDayOfLastYear = new Date(today.getFullYear() - 1, 11, 31).toISOString().split('T')[0];
            search({
                type: 1,
                end_due_date: lastDayOfLastYear,
                start_due_date: firstDayOfLastYear
            });
        }

        if (type == 4) {
            futureDateStr = futureDate.toISOString().split('T')[0]
            search({
                type: 1,
                end_due_date: futureDateStr,
                start_due_date: todayStr
            });
        }

    }

    function handleChangeFastStatusFilter(type) {

        const today = new Date();
        let firstDayOfMonth = 0
        let lastDayOfMonth = 0
        let firstDayOfYear = 0
        let lastDayOfYear = 0
        let firstDayOfLastYear = 0
        let lastDayOfLastYear = 0
        let todayStr = today.toISOString().split('T')[0]
        let futureDate = new Date()
        futureDate.setDate(today.getDate() + 16)
        let futureDateStr = 0

        if (type == 1) {
            search({
                type: 1,
                status: 0
            })
        }

        if (type == 2) {
            search({
                type: 1,
                status: 1
            })
        }

        if (type == 3) {
            search({
                type: 1,
                status: 2
            })
        }

        if (type == 4) {
            search({
                type: 1,
                status: 3
            })
        }
    }

    function handleChangeFastEndCountFilter(type) {

        if (type == 1) {
            search({
                type: 1,
                end_count: 10
            })
        }

        if (type == 2) {
            search({
                type: 1,
                end_count: 20
            })
        }

        if (type == 3) {
            search({
                type: 1,
                end_count: 50
            })
        }

        if (type == 4) {
            search({
                type: 1,
                end_count: 100
            })
        }
    }


    function handleClick() {
        setLoading(true);
        startTrial()
            .then((resp) => {
                setTrialDate({
                    startDate: formatDate(resp["activated!"].start),
                    endDate: formatDate(resp["activated!"].end),
                });
                setShowTrial(true);
                setInterval(() => {
                    window.location.href = "financial/pay-out";
                }, 10000);
            })
            .catch((error) => {
                if (error === "module_already_activate") {
                    toastify.error("Já foi solicitado o teste grátis!", { position: "top-center" })
                } else {
                    setLoading(false);
                }
                setShowTrial(false);
            });
    }


    function init() {
        // if(!accessFinancialModule(context)){
        //     setShowNotAllowed(true)
        //     return
        // }
        setLoading(true)
        _getTransacations()
            .then(() => {
                getPaymentMethods()
                    .then(pays => setPaymentMethodsList(pays))

                getCustomPaymentMethods()
                    .then(pays => setCustomPaymentMethodsList(pays))

            })
            .catch(e => {

                if (e.status == 403) {

                    setShowNotAllowed(true)
                }
            })

            .finally(() => {
                setLoading(false)
            })
    }
    React.useEffect(init, [context.currentBranch, ref.current])

    return <div className='' ref={ref}>

        <Form.Group className="mt-3">
            <Form.Control as="select" value={language} onChange={handleChangeLanguage} style={{ width: 'auto' }}>
                <option value="pt">🇧🇷</option>
                <option value="en">🇺🇸</option>
                <option value="es">🇪🇸</option>
            </Form.Control>
        </Form.Group>

        <div className="d-flex justify-content-between mb-3">
            <div></div>
            <div className="text-center">
                <h1 className=' h3'>{international.paymentsIn.title}</h1>
                {/* Criar */}

                <Button disabled={ShowNotAllowed} onClick={onHandleShow}>{international.paymentsIn.buttons.createButton}</Button>


            </div>
            <div className="d-flex my-auto">
                <Filters disabled={ShowNotAllowed} search={search} type={1} />
            </div>
        </div>

        <div className="row mb-2">
            <div className='col-6'>
                <h3 className='text-center' onClick={getTotal}>{international.paymentsIn.screenTexts.received}:</h3>
                <h4 className='text-center'>{formatCurrencyValue(totalData.received)}</h4>
            </div>
            <div className='col-6'>
                <h3 className='text-center'>{international.paymentsIn.screenTexts.toReceive}:</h3>
                <h4 className='text-center'>{formatCurrencyValue(totalData.to_receive)}</h4>
            </div>
        </div>

        <div className='mt-4 mb-2 ml-3'>

            {/* <Text>Filtro Rápido:</Text> */}

            <div className='row'>

                <div>
                    <Text>Data de Vencimento:</Text>
                    <Form.Group className="">
                        <Form.Control as="select" style={{ width: 'auto' }}>
                            <option onClick={e => { handleChangeFastFilter(e.target.value) }} value={1}>Esse Mês</option>
                            <option onClick={e => { handleChangeFastFilter(e.target.value) }} value={2}>Esse Ano</option>
                            <option onClick={e => { handleChangeFastFilter(e.target.value) }} value={3}>Ano Passado</option>
                            <option onClick={e => { handleChangeFastFilter(e.target.value) }} value={4}>Próximos 15 Dias</option>
                        </Form.Control>
                    </Form.Group>
                </div>

                <div className="ml-2">
                    <Text>Status:</Text>
                    <Form.Group  >
                        <Form.Control as="select" style={{ width: 'auto' }}>
                            <option onClick={e => { handleChangeFastStatusFilter(e.target.value) }} value={1}>Todos</option>
                            <option onClick={e => { handleChangeFastStatusFilter(e.target.value) }} value={2}>A Pagar</option>
                            <option onClick={e => { handleChangeFastStatusFilter(e.target.value) }} value={3}>Pago</option>
                            <option onClick={e => { handleChangeFastStatusFilter(e.target.value) }} value={4}>Cancelado</option>
                        </Form.Control>
                    </Form.Group>
                </div>

                <div className="ml-2">
                    <Text>Exibir:</Text>

                    <Form.Group className="">
                        <Form.Control as="select" style={{ width: 'auto' }}>
                            <option onClick={e => { handleChangeFastEndCountFilter(e.target.value) }} value={1}>10</option>
                            <option onClick={e => { handleChangeFastEndCountFilter(e.target.value) }} value={2}>20</option>
                            <option onClick={e => { handleChangeFastEndCountFilter(e.target.value) }} value={3}>50</option>
                            <option onClick={e => { handleChangeFastEndCountFilter(e.target.value) }} value={4}>100</option>
                        </Form.Control>
                    </Form.Group>
                </div>

            </div>
        </div>

        <TableData
            tHead={["#",
                international.paymentsIn.tableData.description,
                international.paymentsIn.tableData.status,
                international.paymentsIn.tableData.value,
                international.paymentsIn.tableData.person,
                international.paymentsIn.tableData.category,
                international.paymentsIn.tableData.costCenter,
                international.paymentsIn.tableData.dueDate,
                international.paymentsIn.tableData.paymentMethod,
                "Tipo de custo",
                international.paymentsIn.tableData.actions]}
            data={transactionList}
            tBodyKeys={["idx", "description", "status", "value", 'recipient', "category", "cost_center", "due_date", "payment_method", 'cost_type', "actions"]}
        />

        <DownloadReport icon request={filterTransaction} params={reportParams} />


        <Modal title={international.paymentsIn.title} onHide={onHandleShow} show={show}>
            <div className="container row" id="modal-create">
                <div className="col-12">
                    <div className="text-center m-0 py-3">
                        <span className=""></span>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            {international.paymentsIn.modalFields.description}*
                        </Text>
                        <FormControl
                            name='description'
                            placeholder='Insira uma descrição'
                            disabled={loading}
                            onChange={onChange}
                            value={data.description}
                            required
                        />
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            {international.paymentsIn.modalFields.value} (R$)*
                        </Text>
                        <CurrencyInput
                            prefix="R$ "
                            className="form-control"
                            decimalSeparator=","
                            thousandSeparator="."
                            precision="2"
                            name='payment:value'
                            required
                            disabled={loading}
                            onChange={(a, b, c) => { onChange({ target: { value: b, name: "payment:value" } }) }}
                            value={tempValue}
                        />
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    {/* <div className='row'> */}


                    <div className="form-group">

                        <Text color='primary'>
                            {international.paymentsIn.modalFields.paymentMethod}*
                        </Text>
                        <FormControl
                            disabled={loading}
                            name="payment:payment_method"
                            onChange={onChange}
                            as="select"
                        >
                            <option disabled>
                                Selecione
                            </option>
                            {/* 
                                usar customPaymentMethodsList se existir, pensar pre sprint
                                
                                 */}
                            {
                                paymentMethodsList.map(item => {
                                    return <option
                                        key={item.id}
                                        value={item.id}
                                        selected={data.payment.payment_method === item.id} >
                                        {item.name}
                                    </option>
                                })
                            }
                        </FormControl>

                    </div>
                    {/* <i onClick={onHandleTempShow} className="fas pt-4 fa-plus form-group" /> */}
                </div>
                {/* </div> */}

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">

                        <Text color='primary'>
                            {international.paymentsIn.modalFields.person}:
                        </Text>
                        <AutoComplete

                            request={getClients}
                            searchField='name'
                            labelField='name'
                            valueField='original_id'
                            onChange={e => {

                                onChange({ target: { name: 'payment:recipient', value: e.value } })
                            }}
                            onSelect={e => {

                                onChange({ target: { name: 'payment:recipient', value: e.value } })
                            }}
                        />

                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <PaymentCategory title={international.paymentsIn.modalFields.category} allowCreate={true} selected={data.category} onChange={e => onChange({ target: { name: 'category', value: e.target.value } })} />
                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        {/* centro de custo */}
                        <PaymentCostCenter title={international.paymentsIn.modalFields.costCenter} allowCreate={true} selected={data.cost_center} onChange={e => onChange({ target: { name: 'cost_center', value: e.target.value } })} />
                    </div>
                </div>
                <div className='col-lg-6 col-sm-12'>
                    <div className='form-group'>
                        <div>
                            <div>
                                <Text color='primary'>
                                    {international.paymentsIn.modalFields.dueDate}*
                                </Text>
                            </div>
                            <div>
                                <LoadingInput name="payment:due_date" onChange={onChange} value={data.payment.due_date} type="date" />
                            </div>
                        </div>
                    </div>
                </div>





                <div className='col-lg-6 col-sm-12'>
                    <div className='form-group'>
                        <div>
                            <div>
                                <Text color='primary'>
                                    {international.paymentsIn.modalFields.cost_type.title}*
                                </Text>
                            </div>
                            <div>
                                <FormControl
                                    loading={loading}
                                    name="cost_type"
                                    onChange={onChange}
                                    as="select" >
                                    <option selected={costTypeChoices == 1} value='1'>{international.paymentsIn.modalFields.cost_type.variable}</option>
                                    <option selected={costTypeChoices == 2} value='2'>{international.paymentsIn.modalFields.cost_type.fixed}</option>
                                </FormControl>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='col-lg-6 col-sm-12'>
                    <CheckBox
                        onClick={() => handleRepeatShow()}
                        checked={repeatShow}
                        label="Repetir?"
                    />
                </div>

                {repeatShow ?
                    <div className='col-lg-6 col-sm-12'>
                        <div className='form-group'>

                        </div>
                    </div>
                    :
                    <React.Fragment />}

                {repeatShow ?
                    <div className='col-lg-6 col-sm-12'>
                        <div className='form-group'>
                            <div>
                                <div>
                                    <Text color='primary'>
                                        Quantidade:
                                    </Text>
                                </div>
                                <div>
                                    <FormControl
                                        loading={loading}
                                        name="repeat"
                                        onChange={onChange}
                                        as="select" >
                                        <option selected value={1}>1 Vez </option>
                                        {/* <option value={1}>1x</option> */}
                                        <option value={2}>2 Vezes</option>
                                        <option value={3}>3 Vezes</option>
                                        <option value={4}>4 Vezes</option>
                                        <option value={5}>5 Vezes</option>
                                        <option value={6}>6 Vezes</option>
                                        <option value={7}>7 Vezes</option>
                                        <option value={8}>8 Vezes</option>
                                        <option value={9}>9 Vezes</option>
                                        <option value={10}>10 Vezes</option>
                                        <option value={11}>11 Vezes</option>
                                        <option value={12}>12 Vezes</option>
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <React.Fragment />}


                {repeatShow ?
                    <div className='col-lg-6 col-sm-12'>
                        <div className='form-group'>
                            <div>
                                <div>
                                    <Text color='primary'>
                                        Período*
                                    </Text>
                                </div>
                                <div>
                                    <FormControl
                                        loading={loading}
                                        name="date_period"
                                        onChange={onChange}
                                        as="select">
                                        <option value={1} selected>Mensalmente</option>
                                        <option value={2} >Semanalmente</option>
                                        <option value={3} >Anualmente</option>
                                        {/* <option value={4} >4</option> */}
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    <React.Fragment />}




                {/* fim  */}
            </div>



            <div className="col-md-12">
                <div className="d-flex justify-content-center">
                    <Button onClick={_createTransaction} disabled={loading}>
                        {international.paymentsIn.buttons.modalConfirmButton}
                    </Button>
                </div>
            </div>
        </Modal>


        <Modal title={"Criar método de pagamento"} onHide={onHandleTempShow} show={tempShow}>
            <div className="container row" id="modal-create">
                <div className="col-12">
                    <div className="text-center m-0 py-3">
                        <span className=""></span>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            nome da forma*
                        </Text>
                        <FormControl
                            placeholder='Insira um nome'
                            disabled={loading}
                            onChange={e => setCustomPaymentMethod(e.target.value)}
                            value={customPaymentMethod}
                            required
                        />
                    </div>
                </div>
            </div>


            <div className="col-md-12">
                <div className="d-flex justify-content-center">
                    <Button onClick={() => _createCustomPaymentMethod({ name: customPaymentMethod })}>
                        Cadastrar
                    </Button>
                </div>
            </div>
        </Modal>


        <Dialog onHide={() => { setShowAlertConfirmPay(false) }} show={ShowAlertConfirmPay} type={"custom"}>
            <h2>Receber {currentTransaction.description}</h2>

            <div className='col-12'>
                <div className='form-group'>
                    <div>
                        <div>
                            <Text color='primary'>
                                {international.paymentsIn.actions.confirm.confirmValue}
                            </Text>
                        </div>
                        <div>
                            <CurrencyInput
                                required
                                prefix="R$ "
                                className="form-control"
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                disabled={loading}

                                onChange={(a, b, c) => setTempPaidValue(b)}
                                value={tempPaidValue}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className='col-12'>
                <div className='form-group'>
                    <div>
                        <div>
                            <Text color='primary'>
                                {/* Desconto */}
                                {international.paymentsIn.actions.confirm.confirmDiscount}
                            </Text>
                        </div>
                        <div>
                            <CurrencyInput
                                required
                                prefix="R$ "
                                className="form-control"
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                disabled={loading}

                                onChange={(a, b, c) => setTempDiscountValue(b)}
                                value={tempDiscountValue}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {tempPaidValue == currentTransaction.value ?

                <React.Fragment />
                :

                <div className='col-12'>
                    <div className='form-group'>
                        <div>
                            <div>
                                <Text color='primary'>
                                    Próximo Vencimento:
                                </Text>
                            </div>
                            <div>
                                <LoadingInput onChange={e => {
                                    setTempDueDate(e.target.value)
                                }} value={tempDueDate} type="date" />
                            </div>
                        </div>
                    </div>
                </div>

            }

            <div className='row'>


                <div className='col-6'>
                    <div className='form-group'>
                        <div>
                            <div>
                                <Text color='primary'>
                                    Multa
                                </Text>
                            </div>
                            <div>
                                <CurrencyInput
                                    required
                                    prefix="R$ "
                                    className="form-control"
                                    decimalSeparator=","
                                    thousandSeparator="."
                                    precision="2"
                                    disabled={loading}

                                    onChange={(a, b, c) => setTempTax(b)}
                                    value={tempTax}
                                />
                            </div>
                        </div>
                    </div>
                </div>


                <div className='col-6'>
                    <div className='form-group'>
                        <div>
                            <div>
                                <Text color='primary'>
                                    Taxa
                                </Text>
                            </div>
                            <div>
                                <CurrencyInput
                                    required
                                    prefix="R$ "
                                    className="form-control"
                                    decimalSeparator=","
                                    thousandSeparator="."
                                    precision="2"
                                    disabled={loading}

                                    onChange={(a, b, c) => setTempPenalty(b)}
                                    value={tempPenalty}
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <Button onClick={PayTransaction}>
                Confirmar
            </Button>
        </Dialog>

        <Dialog onHide={() => { setShowAlertCancelPay(false) }} show={ShowAlertCancelPay} type={"info"}>
            <h2>Cancelar Conta?</h2>
            <Button onClick={CancelationTransaction}>
                Sim
            </Button>
        </Dialog>


        <Dialog onHide={() => { setShowAlertEditPay(false) }} show={ShowAlertEditPay} type={"info"}>
            <h2>Editar {currentTransaction.description}</h2>

            <div className='col-12'>
                <div className='form-group'>
                    <div>
                        <div>
                            <Text color='primary'>
                                Novo Valor
                            </Text>
                        </div>
                        <div>
                            <CurrencyInput
                                required
                                prefix="R$ "
                                className="form-control"
                                decimalSeparator=","
                                thousandSeparator="."
                                precision="2"
                                disabled={loading}

                                onChange={(a, b, c) => setChangeableValue(b)}
                                value={changeableValue}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <Button onClick={UpdateTransactionData}>
                Confirmar
            </Button>
        </Dialog>


        <Dialog onHide={() => { window.location.href = "/" }} show={ShowNotAllowed} type={"info"}>


            <h2>Seu plano não tem acesso a esse módulo, faça um <a href='/plans'>Upgrade de plano</a> para usar. ou <a href="///" onClick={handleClick}>teste gratuitamente</a> por sete dias.</h2>

        </Dialog>

        <Dialog onHide={() => { setShowAlertDetails(false) }} show={ShowAlertDetails} type={"none"}>


            <div className="container row" id="modal-create">
                <div className="col-12">
                    <div className="text-center m-0 py-3">
                        <h1 className="">{currentTransaction.description}</h1>
                    </div>
                </div>

                <div className="col-12">
                    <div className="text-center m-0 py-3">
                        <Text color='primary'>
                            Status da conta: <span style={{ color: '#040f1f' }}>{StatusChoices[currentTransaction.status]}</span>
                        </Text>
                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            {international.paymentsIn.modalFields.value}:
                        </Text>
                        {formatCurrencyValue(currentTransaction.value)}

                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            Valor Recebido:
                        </Text>
                        {formatCurrencyValue(currentTransaction.paid_value)}
                    </div>
                </div>


                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            Taxa:
                        </Text>
                        {formatCurrencyValue(currentTransaction.tax ? currentTransaction.tax : 0)}
                    </div>
                </div>



                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            Multa:
                        </Text>
                        {formatCurrencyValue(currentTransaction.penalty ? currentTransaction.penalty : 0)}
                    </div>
                </div>


                <div className="col-lg-6 col-sm-12">

                    <div className="form-group">

                        <Text color='primary'>
                            {international.paymentsIn.modalFields.paymentMethod}:
                        </Text>
                        {currentTransaction.payment_method ? currentTransaction.payment_method.name : ''}


                    </div>
                </div>

                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">

                        <Text color='primary'>
                            {international.paymentsIn.modalFields.person}:
                        </Text>

                        {currentTransaction.recipient ? currentTransaction.recipient.name : 'Não Informado'}

                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            Categoria:
                        </Text>
                        {currentTransaction.category ? currentTransaction.category.name : 'Não Informado'}

                    </div>
                </div>
                <div className="col-lg-6 col-sm-12">
                    <div className="form-group">
                        <Text color='primary'>
                            Centro de Custo:
                        </Text>
                        {currentTransaction.cost_center ? currentTransaction.cost_center.name : 'Não Informado'}
                    </div>
                </div>
                <div className='col-lg-6 col-sm-12'>
                    <div className='form-group'>
                        <div>
                            <div>
                                <Text color='primary'>
                                    {international.paymentsIn.modalFields.dueDate}:
                                </Text>
                            </div>
                            {formatDate(currentTransaction.due_date)}
                        </div>
                    </div>
                </div>

                {currentTransaction.paid_date ?

                    <div className='col-lg-6 col-sm-12'>
                        <div className='form-group'>
                            <div>
                                <div>
                                    <Text onClick={() => { console.log(currentTransaction) }} color='primary'>
                                        Data de Recebimento
                                    </Text>
                                </div>
                                {formatDate(currentTransaction.paid_date)}
                            </div>
                        </div>
                    </div>

                    :

                    <div />

                }

                <div className='col-lg-6 col-sm-12'>
                    <div className='form-group'>
                        <div>
                            <div>
                                <Text color='primary'>
                                    {international.paymentsIn.modalFields.cost_type.title}:
                                </Text>
                            </div>
                            <div>
                                {currentTransaction.cost_type == 1 ? international.paymentsIn.modalFields.cost_type.variable : international.paymentsIn.modalFields.cost_type.fixed}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </Dialog>

    </div>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Financial/PaymentsIn/index.jsx